import React, {useRef} from 'react';

import {EEventType} from 'coreClasses/events/IEvents';
import {useCustomerMgr, useMedia} from 'coreHooks';
import {useCategory} from 'coreHooks/categories';
import {appendParamsToURL} from 'coreUtils/url';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import Button from 'brandComponents/Button';
import {IButtonProps} from 'brandComponents/Button/IButton';
import {useHeaderCtx} from 'brandComponents/Header/HeaderCtx';
import {usePromotionViewEvent} from 'brandHooks/usePromotionViewEvent';
import {useTrackPromotionEvent} from 'brandHooks/useTrackPromotionEvent';

import {EButtonLinkTarget, IButtonContentfulProps} from './IButtonContentful';

const ButtonContentful = (props: IButtonContentfulProps) => {
	const {managerRepository} = useGeneralProvider();
	const headerCtx = useHeaderCtx(true);
	const media = useMedia();
	const isMobile = media('<=small');
	const CustomerMgr = useCustomerMgr();
	const {isRegistered} = CustomerMgr.getCurrentCustomer();
	const buttonRef = useRef(null);
	const category = useCategory(props.targetCategory);
	const {trackPromotionEvent} = useTrackPromotionEvent();

	const attrs: IButtonProps = {
		url: props.targetPage?.props?.slug || props.targetUrl,
		title: props.title,
		variant: (props.variant?.toLowerCase() as IButtonContentfulProps['variant']) || 'primary',
		fullWidth: isMobile ? true : props.fullWidth,
		onClick: headerCtx?.isInHeaderContext ? headerCtx.handleNavigationVisibility : () => {},
	};

	if (props.linkTarget) {
		attrs.target = EButtonLinkTarget[props.linkTarget];
	}
	// If it points to a category

	if (props?.targetCategory && category?.getUrl()) {
		attrs.url =  category?.getUrl();
	}

	if (props?.queryParameters) {
		attrs.url = appendParamsToURL(attrs.url, props.queryParameters);

		attrs.onClick = () => {
			attrs.onClick;
			trackPromotionEvent(attrs.url, EEventType.SELECT_BRAND_PROMOTION);
		};
	}

	usePromotionViewEvent(buttonRef, attrs.url);

	if (props?.targetElement === 'LoginCta') {
		return (
			<Button
				ref={buttonRef}
				onClick={() => {
					if (!isRegistered) {
						managerRepository.getFlyoutsMgr().openFlyout('login', true);
					}
				}}
				classNames="open-flyout"
				{...attrs}
				url={isRegistered && '/myaccount'}
			>
				{props.title}
			</Button>
		);
	}

	return <Button {...attrs}>{props.title}</Button>;
};

export default ButtonContentful;
